/**
 * The file names an ERA may arrive under. Shared by the upload picker and the
 * S3 ERA inbox (TES-3198), so the inbox imports exactly what the picker accepts.
 *
 * Plain CommonJS like its neighbours: the front-end build has no TypeScript
 * loader for ts-common. Types live in the adjacent .d.ts.
 */

// ERA files arrive under many names: the X12 835 transaction set itself (.835), generic ERA/EDI
// names, or plain-text exports (TES-3070).
const ERA_ACCEPTED_FILES = {
    'application/edi-x12': ['.835', '.edi', '.era'],
    'text/plain': ['.txt', '.text', '.lst', '.log'],
    'application/octet-stream': ['.dat'],
    'text/*': ['.csv', '.tsv'],
};

const ERA_ACCEPTED_EXTENSIONS = Object.values(ERA_ACCEPTED_FILES).flat().sort();

/** Whether a file name ends in one of the accepted extensions, in any letter case. */
const isEraFileName = (name) => {
    const lower = String(name || '').toLowerCase();

    return ERA_ACCEPTED_EXTENSIONS.some((extension) => lower.endsWith(extension));
};

module.exports = {
    ERA_ACCEPTED_FILES,
    ERA_ACCEPTED_EXTENSIONS,
    isEraFileName,
};
